import React from "react";
import { Link } from "react-router-dom";
import { Camera } from "lucide-react";
import { parkingPhotoEditPath, parkingPhotoStatus } from "../lib/parkingImages";

export default function ParkingMissingPhotosBanner({ spot, className = "" }) {
  const status = parkingPhotoStatus(spot);
  if (!status) return null;

  const editTo = parkingPhotoEditPath(spot.spot_id);
  const label = status.missing
    ? "Photos missing — re-upload"
    : "Using placeholder photo — add real photos";

  return (
    <div
      className={`flex items-center gap-2 px-3 py-2 text-xs text-[var(--zc-text-2)] border-t border-[var(--zc-border)] bg-[var(--zc-bg-2)] ${className}`}
      data-testid={`parking-photos-banner-${spot.spot_id}`}
    >
      <Camera size={12} className="shrink-0 text-[var(--zc-warn)]" />
      <span>{label}</span>
      <Link to={editTo} className="ml-auto font-semibold text-[var(--zc-accent)] hover:underline shrink-0">
        Add photos
      </Link>
    </div>
  );
}
